import React from 'react';
import {IDownloadManualListItem} from "../interfaces/interfaces";

const DownloadManualItem = (props:IDownloadManualListItem) => {
    const currentDownloadManualItem = props;
    return (
        <li><a target="_blank" rel="noreferrer" className="no-underline text-base"
               href={currentDownloadManualItem.manualPDF}>{currentDownloadManualItem.documentName}</a></li>
    )
}

export default DownloadManualItem;